<template lang="pug">
  self-layout(
    :value="!!blockingMenu"
    @input="handleInput"
    @scroll-top="updateScrollTop"
    :select="$get(blockingMenu, `select`)"
    :items="$get(blockingMenu, `items`)")
    template(#title) {{ $get(blockingMenu, `title`) }}
    template(#items)
      self-items(
        :is-choice="isChoice"
        :max-selected-items-reached="maxSelectedItemsReached"
        :items="$get(blockingMenu, `items`)")
</template>

<script>
import { state } from '..'
import { toRefs, computed } from '@vue/composition-api'
import { page } from '@iez/core'
import { mdiCheck } from '@mdi/js'
import pluralize from '@iez/lib/pluralize'

import SelfLayout from './layout/'
import SelfItems from './items/'

export default {
  components: {
    SelfLayout,
    SelfItems
  },

  setup () {
    const isChoice = computed(
      () => state.blockingMenu?.select?.max === 1
    )

    const updateScrollTop = ({ scrollTop }) => {
      state.scrollTop = scrollTop
    }

    const selectedItems = computed(
      () => (state.blockingMenu?.items ?? [])
        .map(({ value }) => !!value)
    )
    const selectedItemsCount = computed(
      () => selectedItems.value.reduce(
        (accumulator, currentValue) =>
          currentValue
            ? accumulator + 1
            : accumulator,
        0
      )
    )
    const maxSelectedItemsReached = computed(
      () => selectedItemsCount.value === state.blockingMenu?.select?.max
    )

    page.bottomShortcut.add(
      () =>
        selectedItemsCount.value >= state.blockingMenu?.select?.min
          ? {
            action: {
              onClick: () => {
                state.blockingMenu?.onResult({
                  indexes: state.blockingMenu?.items
                    .map(({ value }, index) => ({
                      value,
                      index
                    })).filter(({ value }) => !!value)
                    .map(({ index }) => index)
                })
                state.blockingMenu?.onClose()
                state.blockingMenu = null
              },
              icon: mdiCheck,
              label: isChoice.value
                ? `Valider`
                : `Valider (${selectedItemsCount.value})`
            }
          } : null
    )

    const handleInput = value => {
      if (!value) {
        // closing
        state.blockingMenu?.onClose()
        state.blockingMenu = null
      }
    }

    return {
      ...toRefs(state),
      updateScrollTop,
      maxSelectedItemsReached,
      handleInput,
      isChoice
    }
  }
}
</script>

